import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex);
const store = new Vuex.Store({
  //自定义的变量和数据源
  state:{
  },
  //用来触发事件,更改Vuex store 中的数据源,同步
  mutations:{
  },
  //类似于计算属性
  getters:{

  },
  //对异步更改状态
  actions:{

  },
  //对Vuex 单一状态树进行模块分割
  modules:{

  },
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js